import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=1b1b61b8&"
import script from "./Estoque.vue?vue&type=script&lang=js&"
export * from "./Estoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports